import React, { FC } from 'react'
import model from './model.en.json'
import styles from './styles.module.scss'

type FooterProps = { content?: string }
const DEFAULT_CONTENT = model.defaultContent
const termsOfUseUrl = process.env.REACT_APP_AKILI_TOU_LINK
const privacyNoticeUrl = process.env.REACT_APP_AKILI_PP_LINK

const Footer: FC<FooterProps> = ({ content }) => {
  return (
    <div className={styles.footer}>
      <div className={styles.content}>
        <span>{content || DEFAULT_CONTENT}</span>
        &nbsp;
        <a href={termsOfUseUrl} target="_blank" rel="noreferrer">
          {model.termsOfUse}
        </a>
        <span> | </span>
        &nbsp;
        <a href={privacyNoticeUrl} target="_blank" rel="noreferrer">
          {model.privacyNotice}
        </a>
      </div>
    </div>
  )
}

export default Footer
